package com.trevorwiebe.timesheet.punch.domain

import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.core.domain.model.Punch
import com.trevorwiebe.timesheet.core.domain.model.TimeSheet
import kotlinx.coroutines.flow.Flow
import kotlinx.datetime.LocalDateTime

interface PunchRepository {

    suspend fun getRates(): TSResult

    suspend fun updatePunch(punch: Punch, userId: String? = null): TSResult

    suspend fun updatePunchesWithNewRate(punchIn: Punch, punchOut: Punch?, userId: String? = null): TSResult

    suspend fun getPunches(startDate: LocalDateTime, endDate: LocalDateTime, userId: String? = null): Flow<TSResult>

    /**
     * One-shot read of punches in a date range, as opposed to the realtime [getPunches] listener.
     * Used by point-in-time reads (e.g. the admin Employee Hour Reports). Callers fanning out across
     * many users should pass [organizationId] (resolved once) so each read skips re-resolving it via auth.
     */
    suspend fun getPunchesOnce(
        startDate: LocalDateTime,
        endDate: LocalDateTime,
        userId: String? = null,
        organizationId: String? = null,
    ): TSResult

    suspend fun addPunch(punch: Punch, userId: String? = null): TSResult

    suspend fun addHours(startPunch: Punch, endPunch: Punch, userId: String? = null): TSResult

    suspend fun deletePunches(punchIds: List<String?>, userId: String? = null): TSResult

    suspend fun updateTimeSheet(timeSheet: TimeSheet, userId: String? = null): TSResult

    suspend fun getTimeSheetById(id: String, userId: String? = null): Flow<TSResult>

    suspend fun adjustVacationTimeByHours(hours: Int, userId: String? = null): TSResult

    /**
     * Marks many timesheets as submitted in a single atomic batch. Each entry is a
     * `userId to timeSheetId` pair (timesheets live under per-user subcollections).
     * Used by the admin Employee Hour Reports export to lock the previous pay period.
     */
    suspend fun markTimeSheetsSubmitted(entries: List<Pair<String, String>>): TSResult
}